export default "/videos/757a46354d5b7e5acb7a3d5ef87313dd.mp4";